import {
  ServerInvitationFetch,
  StoreInvitation,
  CancelInvitationAction,
  CancelInvitationFailAction,
  CancelInvitationSuccessAction,
  ClearInvitationErrorAction,
  CreateInvitationAction,
  CreateInvitationFailAction,
  CreateInvitationSuccessAction,
  FetchInvitationsAction,
  FetchInvitationsFailAction,
  FetchInvitationsSuccessAction,
  SetInvitationErrorAction,
} from '@funnels/types';
import { REDUX_STORE } from '@funnels/constants';

export function cancelInvitation(invitationId: string, unauthorised?: boolean): CancelInvitationAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.CANCEL_INVITATION, invitationId, unauthorised };
}

export function cancelInvitationFail(): CancelInvitationFailAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.CANCEL_INVITATION_FAIL };
}

export function cancelInvitationSuccess(): CancelInvitationSuccessAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.CANCEL_INVITATION_SUCCESS };
}

export function clearInvitationError(): ClearInvitationErrorAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.CLEAR_INVITATION_ERROR };
}

export function createInvitation(invitation: StoreInvitation): CreateInvitationAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.CREATE_INVITATION, invitation };
}

export function createInvitationFail(): CreateInvitationFailAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.CREATE_INVITATION_FAIL };
}

export function createInvitationSuccess(clientId: string, serverId: string): CreateInvitationSuccessAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.CREATE_INVITATION_SUCCESS, clientId, serverId };
}

export function fetchInvitations(applicationId: string): FetchInvitationsAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.FETCH_INVITATIONS, applicationId };
}

export function fetchInvitationsFail(): FetchInvitationsFailAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.FETCH_INVITATIONS_FAIL };
}

export function fetchInvitationsSuccess(data: ServerInvitationFetch[]): FetchInvitationsSuccessAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.FETCH_INVITATIONS_SUCCESS, data };
}

export function setInvitationError(message: string = 'Unknown error'): SetInvitationErrorAction {
  return { type: REDUX_STORE.INVITATIONS.ACTION_TYPES.SET_INVITATION_ERROR, message };
}
